import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Sidebar from '../components/common/Sidebar';
import TreatmentHistory from '../components/treatments/TreatmentHistory';
import TreatmentForm from '../components/treatments/TreatmentForm';
import treatmentService from '../services/treatmentService';

const Treatments = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showForm, setShowForm] = useState(false);
  const [selectedTreatment, setSelectedTreatment] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const [stats, setStats] = useState(null);

  // Handle navigation from patient profile
  useEffect(() => {
    if (location.state?.openAddTreatment && location.state?.patient) {
      handleAddTreatment();
    }
  }, [location.state]);

  useEffect(() => {
    fetchStats();
  }, [refreshKey]);

  const fetchStats = async () => {
    try {
      const response = await treatmentService.getTreatmentStats();
      setStats(response.data);
    } catch (error) {
      console.error('Error fetching stats:', error);
    }
  };

  const handleAddTreatment = () => {
    setSelectedTreatment(null);
    setShowForm(true);
  };

  const handleEditTreatment = (treatment) => {
    setSelectedTreatment(treatment);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedTreatment(null);
  };

  const handleSuccess = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      
      <div className="flex">
        <Sidebar />
        
        <div className="flex-1 p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900">Treatment Notes</h1>
            <p className="text-gray-600 mt-1">
              Document and track patient treatment sessions
            </p>
          </div>

          {/* Quick Stats */}
          {stats && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
              <div className="bg-blue-50 p-4 rounded-lg">
                <p className="text-sm text-blue-600 font-medium">Total Sessions</p>
                <p className="text-2xl font-bold text-blue-700">{stats.total_treatments}</p>
              </div>
              <div className="bg-green-50 p-4 rounded-lg">
                <p className="text-sm text-green-600 font-medium">Patients Treated</p>
                <p className="text-2xl font-bold text-green-700">{stats.unique_patients}</p>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg">
                <p className="text-sm text-purple-600 font-medium">This Month</p>
                <p className="text-2xl font-bold text-purple-700">{stats.this_month}</p>
              </div>
              <div className="bg-yellow-50 p-4 rounded-lg">
                <p className="text-sm text-yellow-600 font-medium">Avg Pain Level</p>
                <p className="text-2xl font-bold text-yellow-700">
                  {stats.average_pain_level ? `${stats.average_pain_level}/10` : 'N/A'}
                </p>
              </div>
            </div>
          )}

          <TreatmentHistory
            key={refreshKey}
            onEditTreatment={handleEditTreatment}
            onAddTreatment={handleAddTreatment}
          />
        </div>
      </div>

      {/* Treatment Form Modal */}
      {showForm && (
        <TreatmentForm
          treatment={selectedTreatment}
          onClose={handleCloseForm}
          onSuccess={handleSuccess}
        />
      )}
    </div>
  );
};

export default Treatments;